/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import { Card } from 'roo-ui/components';
import GridDataCell from './GridDataCell';
import GridDataRow from './GridDataRow';

function chunkArray(array, chunkSize) {
  return array.reduce((acc, cellData, index) => {
    if (index % chunkSize === 0) {
      acc.push([]);
    }

    acc[acc.length - 1].push(cellData);

    return acc;
  }, []);
}

const NUM_COLUMNS = 3;

const GridData = ({ data, ...props }) => {
  const rows = chunkArray(data, NUM_COLUMNS);
  const firstCell = data[0];
  const lastCell = data[data.length - 1];

  return (
    <Card px={[5, 6]} py={[5, 0]} mb={[5, 8]} display="flex" flexWrap="wrap" data-testid={props['data-testid']} {...props}>
      {rows.map((rowCells, i) => (
        <GridDataRow key={i}>
          {rowCells.map((cell) => (
            <GridDataCell key={cell.label} {...cell} isFirst={cell === firstCell} isLast={cell === lastCell} />
          ))}
        </GridDataRow>
      ))}
    </Card>
  );
};

GridData.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node,
      value: PropTypes.node,
    }),
  ).isRequired,
};

export default GridData;
